import { useCallback, useEffect, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { templateGalleryState } from './templateGalleryState';

export const DIALOG_TRANSITION_DURATION = 225;

export const useTemplateGalleryModal = () => {
    const [state, setState] = useRecoilState(templateGalleryState);
    const timerRef = useRef<number | null>(null);
    const open = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setState({ isOpen: true, isVisuallyOpen: true });
    }, [setState]);

    const close = useCallback(() => {
        // First set isOpen to false to trigger the fade out animation
        setState(curr => ({ ...curr, isOpen: false }));

        // After animation completes, set isVisuallyOpen to false to remove from DOM
        timerRef.current = window.setTimeout(() => {
            setState(curr => ({ ...curr, isVisuallyOpen: false }));
            timerRef.current = null;
        }, DIALOG_TRANSITION_DURATION);
    }, [setState]);

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    return {
        isOpen: state.isOpen,
        isVisuallyOpen: state.isVisuallyOpen,
        open,
        close,
    };
};
